import CourseProgress from 'pages/open-course/common/models/courseProgress';

import courseProgressData from 'bundles/catalogP/data/courseProgress';
import type { CourseProgressMemoizeOptions, CourseProgressOptions } from 'bundles/catalogP/data/courseProgress';
import createLinkedModels from 'bundles/catalogP/lib/createLinkedModels';
import * as CourseProgressCache from 'bundles/in-course-stores/stores/CourseProgressCache';
import type { RawProgress } from 'bundles/in-course-stores/stores/CourseProgressCache';

export default function (options: CourseProgressOptions, memoizeOptions: CourseProgressMemoizeOptions) {
  return courseProgressData(options, memoizeOptions).then(function (data: RawProgress) {
    CourseProgressCache.invalidateCache(options.id);
    const localProgressData = CourseProgressCache.readProgressFromLocalStorage(options.id);
    const mergedWithLocalData = CourseProgressCache.mergeProgressFromLocalStorage(data, localProgressData);

    return {
      courseProgress: createLinkedModels(CourseProgress.prototype.resourceName, mergedWithLocalData).first(),
      rawCourseProgress: mergedWithLocalData,
    };
  });
}
